// extracted by mini-css-extract-plugin
export default {"card":"BenefitCard_card__+FQ44","svg":"BenefitCard_svg__brRuW","title":"BenefitCard_title__Ei314","desc":"BenefitCard_desc__X6tsL"};